import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  NumberBox,
  SelectBox,
  Template,
  TextArea,
  TextBox,
  DateBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import {
  AssetSubStatus,
  CurrencyIcon,
  DefaultDateFormat,
  PrecisionFormats,
  Features,
} from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import Modal from "react-modal";
import moment from "moment";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
  showWarningMessage,
} from "../../../helper/message";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import Swal from "sweetalert2";
import { useGetCodeWiseAppModuleFeaturePermission } from "../../../helper/sessionHelper";

const modesOfTransportationLst = [
  { id: 1, name: "VSE" },
  { id: 2, name: "Vendor" },
];

export default function UpdateMaterialMovementOrderComponent(props) {
  const user = useSelector((state) => state.user.data);
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    isSubmitted: false,
    isSavingAsDraft: false,
    isApproving: false,
    assetMovementRequestId: location?.state?.requestMovementId ?? 0,
    materialMovementOrderIndentNo:
      location?.state?.materialMovementOrderIndentNo ?? "",
    fromProjectId: 0,
    fromProjectName: "",
    fromLocationName: "",
    toProjectId: 0,
    toProjectName: "",
    toLocationName: "",
    note: "",
    isUpdateAssetMovementRequestSubDetailsModalOpen: false,
    rowData: null,
    modesOfTransportationId: 0,
    modesOfTransportationName: "",
    assetId: 0,
    assetSerialNumber: "",
    assetName: "",
    vehicleNo: "",
    vechicleNoText: "",
    ewayBillNo: "",
    ewayBillExpiryDate: "",
    vendorName: "",
    vendorId: 0,
    transportCharges: 0,
    remark: "Yes Go ahead",
    fromId: user?.userDepartmentId ?? 0,
    requestedDate:
      moment(new Date())
        .format(DefaultDateFormat.SqlDateTimeFullFormat)
        .toString() ?? "",
    userId: 0,
    isValid: false,
    workflowCategoryId: 0,
    workflowDepartmentId: 0,
    workflowId: 0,
    assignTypeId: 0,
    assignTypeName: "",
    custodianUserId1: 0,
    custodian1DeptId: 0,
    custodianUserId2: 0,
    custodian2DeptId: 0,
    custodianUserId3: 0,
    custodian3DeptId: 0,
    assignedVendorId: 0,
    assignedVendorName: "",
    allocatedAssetId: 0,
    isAssentApprove: false,
    isSaveAsDraft: false,
  });
  const [movementOrderAttachment, setMovementOrderAttachment] = useState({
    fileName: "",
    fileUrl: "",
    fileType: "",
    fileSize: 0,
    fileData: "",
    uploadedTemporaryMovementOrderAttachmentLst: [],
  });
  const [errors, setErrors] = useState({
    userValidation: "",
    fromProjectValidation: "",
    toProjectValidation: "",
    noteValidation: "",
    //assetSerialValidation: "",
    modesOfTransportationValidation: "",
    vehicleNoValidation: "",
    vendorNameValidation: "",
    transportChargesValidation: "",
    remarkValidation: "",
    vehicleNoTextValidation: "",
    custodian1DepartmentValidation: "",
    custodian2DepartmentValidation: "",
    custodian3DepartmentValidation: "",
    custodian1UserValidation: "",
    custodian2UserValidation: "",
    custodian3UserValidation: "",
    assignTypeValidation: "",
    assignDepartmentValidation: "",
    assignUserValidation: "",
    assignedVendorValidation: "",
    assignedVendorNameValidation: "",
  });

  const [
    assetMovementRequestSubDataSourceLst,
    setAssetMovementRequestSubDataSourceLst,
  ] = useState([]);
  const [fromProjectDropdown, setFromProjectDropdown] = useState([]);
  const [trailerDropdown, setTrailerDropdown] = useState([]);
  const [toProjectDropdown, setToProjectDropdown] = useState([]);
  const [assetSerialDropdown, setAssetSerialDropdown] = useState([]);
  const [userDropdown, setUserDropdown] = useState([]);
  const [workflowCategoryDropdown, setWorkflowCategoryDropdown] = useState([]);
  const [workflowData, setWorkflowData] = useState([]);
  const [assetRequestApproversByWorkflow, setAssetRequestApproversByWorkflow] =
    useState([]);
  const [assetRequestApprovers, setAssetRequestApprovers] = useState([]);
  const [custodian1DepartmentDropdown, setCustodian1DepartmentDropdown] =
    useState([]);
  const [custodian1UserDropdown, setCustodian1UserDropdown] = useState([]);
  const [custodian2DepartmentDropdown, setCustodian2DepartmentDropdown] =
    useState([]);
  const [custodian2UserDropdown, setCustodian2UserDropdown] = useState([]);
  const [custodian3DepartmentDropdown, setCustodian3DepartmentDropdown] =
    useState([]);
  const [custodian3UserDropdown, setCustodian3UserDropdown] = useState([]);
  const [assignTypeDropdown, setAssignTypeDropdown] = useState([]);
  const [assignDepartmentDropdown, setAssignDepartmentDropdown] = useState([]);
  const [assignUserDropdown, setAssignUserDropdown] = useState([]);
  const [assignedVendorDropdown, setassignedVendorDropdown] = useState([]);
  const [vendorDropdown, setVendorDropdown] = useState([]);

  const refDataGrid = useRef(null);
  const movementOrderfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission("MaterialMovementOrder");

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Movement Order`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    // if (state?.workflowCategoryId > 0) {
    //   GetWorkFlowForApprovers(
    //     state?.workflowCategoryId,
    //     state?.toProjectId,
    //     state.workflowDepartmentId
    //   );
    // } else {
    //   GetWorkFlowForApprovers(
    //     state.workflowCategoryId,
    //     state?.fromProjectId,
    //     state.workflowDepartmentId
    //   );
    // }
    GetWorkFlowForApprovers(
      state?.workflowCategoryId,
      state?.toProjectId,
      state.workflowDepartmentId
    );
  }, [
    state?.fromProjectId,
    state?.workflowCategoryId,
    user?.workflowDepartmentId,
  ]);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getUserDropdown();
      }, 0);
      setTimeout(async () => {
        await getFromProjectDropdown();
      }, 0);
      setTimeout(async () => {
        await getToProjectDropdown();
      }, 0);
      setTimeout(async () => {
        await getWorkflowCategory();
      }, 0);
      setTimeout(async () => {
        await getAssetMovementRequestSub(state.assetMovementRequestId);
      }, 0);
      setTimeout(async () => {
        await getAssetMovementRequest(state.assetMovementRequestId);
      }, 0);
      setTimeout(async () => {
        await getCustodian1DepartmentDropdown();
      }, 0);
      // setTimeout(async () => {
      //   await getCustodian1UserDropdown(state.custodian1DeptId);
      // }, 0);
      setTimeout(async () => {
        await getCustodian2DepartmentDropdown();
      }, 0);
      // setTimeout(async () => {
      //   await getCustodian2UserDropdown(state.custodian2DeptId);
      // }, 0);
      setTimeout(async () => {
        await getCustodian3DepartmentDropdown();
      }, 0);
      // setTimeout(async () => {
      //   await getCustodian3UserDropdown(state.custodian3DeptId);
      // }, 0);
      setTimeout(async () => {
        await getAssignTypetDropdown();
      }, 0);
      setTimeout(async () => {
        await getAssignDepartmentDropdown();
      }, 0);
      setTimeout(async () => {
        await getAssignedUserDropdown(state.assignDepartmentId);
      }, 0);
      setTimeout(async () => {
        await getAssignedVendorDropdown("", state.assignedVendorId);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  const debouncedVendorSearch = useCallback(
    debounce((text) => {
      getVendorDropdown(text, state.vendorId);
    }, 500),
    []
  );

  const getVendorDropdown = async (searchText, vendorId) => {
    try {
      // const response = await vishwamApi.getVendorList(user?.companyId);
      // setVendorDropdown(response?.data?.filter((f) => f.isActive) ?? []);
      if (vendorId > 0) {
        const response = await vishwamApi.GetVendorDropdown();
        setVendorDropdown(
          response?.data?.filter((f) => f.isActive && f.id === vendorId) ?? []
        );
      } else {
        const response = await vishwamApi.GetVendorDropdown2(searchText);
        setVendorDropdown(response?.data?.filter((f) => f.isActive) ?? []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getTrailerDropdown = async () => {
    try {
      const Assetresponse = await assetService.getassetList(0);
      setTrailerDropdown(
        Assetresponse?.data?.filter((f) => f.categoryId === 32) ?? []
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getFromProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectList(body);
      setFromProjectDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getToProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectList(body);
      setToProjectDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getUserDropdown = async () => {
    try {
      const response = await vishwamApi.getUserList();
      setUserDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetSerialDropdown = async () => {
    try {
      const id = state.assetId;
      const response = await assetService.getassetList(0);
      var assets = {};
      assets = response?.data.filter(
        (f) =>
          f.categoryId === state.rowData?.categoryId &&
          f.subCategoryId === state.rowData?.subCategoryId &&
          f.projId === state.fromProjectId &&
          //f.projId === state.toProjectId
          f.statusId === AssetSubStatus.Available
      );
      setAssetSerialDropdown(assets);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignTypetDropdown = async () => {
    try {
      const assignTypeList = [
        { id: 1, name: "Department" },
        { id: 2, name: "User" },
        { id: 3, name: "Vendor" },
      ];
      setAssignTypeDropdown(assignTypeList ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignDepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setAssignDepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignedUserDropdown = async (assignDepartmentId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        assignDepartmentId,
        user?.companyId
      );
      setAssignUserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian1DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1UserDropdown = async (custodian1DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian1DeptId,
        user?.companyId
      );
      setCustodian1UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian2DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2UserDropdown = async (custodian2DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian2DeptId,
        user?.companyId
      );
      setCustodian2UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian3DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian3DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian3UserDropdown = async (custodian3DeptId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian3DeptId,
        user?.companyId
      );
      setCustodian3UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const assignedVendorBounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  const debouncedAssignedVendorSearch = useCallback(
    assignedVendorBounce((text) => {
      getAssignedVendorDropdown(text, state.transportVendorId);
    }, 500),
    []
  );

  const getAssignedVendorDropdown = async (searchText, vendorId) => {
    try {
      // const response = await vishwamApi.getVendorList(user?.companyId);
      // setassignedVendorDropdown(
      //   response?.data?.filter((f) => f.isActive) ?? []
      // );
      if (vendorId > 0) {
        const response = await vishwamApi.GetVendorDropdown();
        setassignedVendorDropdown(
          response?.data?.filter((f) => f.isActive && f.id === vendorId) ?? []
        );
      } else {
        const response = await vishwamApi.GetVendorDropdown2(searchText);
        setassignedVendorDropdown(
          response?.data?.filter((f) => f.isActive) ?? []
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkflowCategory = async (projectId, departmentId) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        projectId: projectId,
        //departmentId: user.userDepartmentId
        departmentId: departmentId,
      };
      const response = await assetService.getWorkflowGroup(body);
      //console.log(JSON.stringify(response?.data));
      setWorkflowCategoryDropdown(response?.data);
      if (response?.data.length === 1) {
        setState((prev) => ({
          ...prev,
          workflowCategoryId: response?.data[0].workflowCategoryId,
          workflowId: response?.data[0].workflowId,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetWorkFlowForApprovers = async (
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      if (
        body.formId > 0 &&
        body.categoryId > 0 &&
        body.projectId > 0 &&
        body.departmentId > 0
      ) {
        const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
        console.log(JSON.stringify(response));
        setWorkflowData(response);
        const stagesWithApprovers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.map((stage) => ({
            actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
            approvers: stage?.approvers,
          }));
        const Approvers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.flatMap((stage) =>
            stage?.approvers?.map((approver) => ({
              actionTypeId: stage?.actionTypeId,
              userId: approver?.userId,
              canEdit: approver?.canEdit,
              stageId: stage?.index,
            }))
          );
        setAssetRequestApprovers(Approvers);
        setAssetRequestApproversByWorkflow(stagesWithApprovers);
        // console.log(Approvers);
      }
    } catch (error) {
      console.log("Error getDepartmentDropdown===>", error);
    }
  };

  const getAssetMovementRequest = async (assetMovementRequestId) => {
    try {
      let body = {
        materialMovementId: assetMovementRequestId,
        statusId: 0,
        userId: user.userId,
      };
      const response = await assetService.getMaterialMovementOrder(body);
      setTimeout(async () => {
        await getWorkflowCategory(
          response?.data[0]?.toProjectId,
          response?.data[0]?.departmentId
        );
        await GetWorkFlowForApprovers(
          response?.data[0]?.workflowId,
          response?.data[0]?.toProjectId,
          response?.data[0]?.departmentId
        );
      }, 0);

      //   setTimeout(async () => {
      //     await getCustodian1UserDropdown(
      //       response?.data[0]?.custodian1DepartmentId
      //     );
      //   }, 0);
      //   setTimeout(async () => {
      //     await getCustodian2UserDropdown(
      //       response?.data[0]?.custodian2DepartmentId
      //     );
      //   }, 0);
      //   setTimeout(async () => {
      //     await getCustodian3UserDropdown(
      //       response?.data[0]?.custodian3DepartmentId
      //     );
      //   }, 0);
      //   setTimeout(async () => {
      //     await getAssignedUserDropdown(response?.data[0]?.assignDepartmentId);
      //   }, 0);

      setState((prev) => ({
        ...prev,
        userId: response?.data[0]?.toId ?? 0,
        fromId: response?.data[0]?.fromId ?? 0,
        toId: state.toId > 0 ? state.toId : response?.data[0]?.toId,
        fromProjectId:
          state.fromProjectId > 0
            ? state.fromProjectId
            : response?.data[0]?.fromProjectId,
        fromProjectName: response?.data[0]?.fromProjectName ?? "",
        fromLocationName: response?.data[0]?.fromLocation ?? "",
        fromDepartmentId: response?.data[0]?.fromDepartmentId ?? 0,
        fromDepartment: response?.data[0]?.fromDepartment ?? "",
        toProjectId: response?.data[0]?.toProjectId ?? 0,
        toProjectName: response?.data[0]?.toProjectName ?? "",
        toLocationName: response?.data[0]?.toLocation ?? "",
        toDepartmentId: response?.data[0]?.toDepartmentId ?? 0,
        toDepartment: response?.data[0]?.toDepartment ?? "",
        note: response?.data[0]?.note ?? "",
        //isValid: response?.data[0]?.isValid ?? false,
        workflowCategoryId: response?.data[0]?.categoryId ?? 0,
        workflowId: response?.data[0]?.workflowId ?? 0,
        workflowDepartmentId: response?.data[0]?.fromDepartmentId ?? 0,

        custodian1DeptId: response?.data[0]?.custodian1DepartmentId ?? 0,
        custodian2DeptId: response?.data[0]?.custodian2DepartmentId ?? 0,
        custodian3DeptId: response?.data[0]?.custodian3DepartmentId ?? 0,

        custodianUserId1: response?.data[0]?.custodianUserId1 ?? 0,
        custodianUserId2: response?.data[0]?.custodianUserId2 ?? 0,
        custodianUserId3: response?.data[0]?.custodianUserId3 ?? 0,

        assignTypeId: response?.data[0]?.assignedTypeId ?? 0,
        assignDepartmentId: response?.data[0]?.assignDepartmentId ?? 0,
        assignedUserId: response?.data[0]?.assignUserId ?? 0,

        assignedVendorId: response?.data[0]?.assignedVendorId ?? 0,
        assignedVendorName: response?.data[0]?.assignedVendorName ?? "",

        allocatedAssetId: response?.data[0]?.allocatedAssetId ?? 0,
        isSaveAsDraft: response?.data[0]?.isSaveAsDraft ?? false,
      }));
      setMovementOrderAttachment((prev) => ({
        ...prev,
        uploadedTemporaryMovementOrderAttachmentLst:
          response?.data[0]?.movementOrderAttachments ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve("");
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handlemovementOrderFileChange = async (e) => {
    try {
      setMovementOrderAttachment((prev) => ({ ...prev, fileData: "" }));
      const movementOrderAttachment = Array.from(e.target.files);
      const newAttachmentPromises = movementOrderAttachment.map(
        async (file) => {
          const base64 = await getBase64(file);
          return {
            noOfRows: Math.random().toString(16).slice(2),
            id: 0,
            movementOrderId: state.assetMovementRequestId,
            fileName: file.name,
            fileSize: file.size,
            filePath: "",
            fileUrl: "",
            fileData: base64,
            fileType: file.type,
            uploadDate: "",
          };
        }
      );
      const newAttachments = await Promise.all(newAttachmentPromises);
      setMovementOrderAttachment((prev) => {
        const existingList =
          prev.uploadedTemporaryMovementOrderAttachmentLst || [];
        return {
          ...prev,
          uploadedTemporaryMovementOrderAttachmentLst: [
            ...existingList,
            ...newAttachments,
          ],
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetMovementRequestSub = async (assetMovementRequestId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      let body = {
        materialMovementId: assetMovementRequestId,
        statusId: 0,
      };
      const response = await assetService.getMaterialMovementOrderById(body);
      //   console.log(response?.data);
      setAssetMovementRequestSubDataSourceLst(
        response?.data?.assetMaterialMovementRequestSub ?? []
      );

      var isValid =
        response?.data?.assetMaterialMovementRequestSub.filter(
          (e) => e.transportationId > 0
        ).length > 0
          ? true
          : false;
      setState((prev) => ({
        ...prev,
        isValid: isValid,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const isValidData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.userValidation = "";
      err.fromProjectValidation = "";
      err.toProjectValidation = "";
      err.noteValidation = "";
      //err.assignTypeValidation = "";
      //   err.custodian1DepartmentValidation = "";
      //   err.custodian1UserValidation = "";
      //   err.custodian2DepartmentValidation = "";
      //   err.custodian2UserValidation = "";
      //   err.custodian3DepartmentValidation = "";
      //   err.custodian3UserValidation = "";
      //   err.assignDepartmentValidation = "";
      //   err.assignUserValidation = "";
      //   err.assignedVendorValidation = "";
      //   err.assignedVendorNameValidation = "";

      if (state.userId === 0) {
        err.userValidation = "Please select To.";
        isValid = false;
      }
      // if (state.fromProjectId === 0) {
      //   err.fromProjectValidation = "Please select from project.";
      //   isValid = false;
      // }
      // if (state.toProjectId === 0) {
      //   err.toProjectValidation = "Please select to project.";
      //   isValid = false;
      // }
      if (state.note == "") {
        err.noteValidation = "Please enter note.";
        isValid = false;
      }
      //   if (state.custodian1DeptId === 0) {
      //     err.custodian1DepartmentValidation =
      //       "Please select customer department 1.";
      //     isValid = false;
      //   }
      //   if (state.custodian1DeptId > 0 && state.custodianUserId1 === 0) {
      //     err.custodian1UserValidation = "Please select customer user 1.";
      //     isValid = false;
      //   }
      //   if (state.custodian2DeptId === 0) {
      //     err.custodian2DepartmentValidation =
      //       "Please select customer department 2.";
      //     isValid = false;
      //   }
      //   if (state.custodian2DeptId > 0 && state.custodianUserId2 === 0) {
      //     err.custodian2UserValidation = "Please select customer user 2.";
      //     isValid = false;
      //   }
      //   if (state.custodian3DeptId === 0) {
      //     err.custodian3DepartmentValidation =
      //       "Please select customer department 3.";
      //     isValid = false;
      //   }
      //   if (state.custodian3DeptId > 0 && state.custodianUserId3 === 0) {
      //     err.custodian3UserValidation = "Please select customer user 3.";
      //     isValid = false;
      //   }
      //   if (state.assignTypeId === 0) {
      //     err.assignTypeValidation = "Please select assign to.";
      //     isValid = false;
      //   }
      // if (state.assignTypeId > 0 && state.assignDepartmentId === 0) {
      //   err.assignDepartmentValidation = "Please select department.";
      //   isValid = false;
      // }
      // if (state.assignTypeId === 2) {
      //   if (state.assignedUserId === 0) {
      //     err.assignUserValidation = "Please select user.";
      //     isValid = false;
      //   }
      // }

      //   if (state.assignTypeId === 1) {
      //     if (state.assignDepartmentId === 0) {
      //       err.assignDepartmentValidation = "Please select department.";
      //       isValid = false;
      //     }

      //     if (state.assignedUserId === 0) {
      //       err.assignUserValidation = "Please select user.";
      //       isValid = false;
      //     }
      //   }

      //   if (state.assignTypeId === 2) {
      //     if (state.assignDepartmentId === 0) {
      //       err.assignDepartmentValidation = "Please select department.";
      //       isValid = false;
      //     }

      //     if (state.assignedUserId === 0) {
      //       err.assignUserValidation = "Please select user.";
      //       isValid = false;
      //     }
      //   }
      //   if (state.assignTypeId === 3) {
      //     if (state.assignedVendorId === 0) {
      //       err.assignedVendorValidation = "Please select vendor.";
      //       isValid = false;
      //     }

      //     if (state.assignedVendorName === "") {
      //       err.assignedVendorNameValidation = "Please enter vendor name.";
      //       isValid = false;
      //     }
      //   }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnSubmitAssetMovementRequestDetails = async (e) => {
    e.preventDefault();
    try {
      if (
        assetMovementRequestSubDataSourceLst?.filter(
          (f) => f.transportationId === 0
        )?.length > 0
      ) {
        await showErrorMessage("Please fill required movement order details!!");
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        return;
      }
      if (isValidData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to update movement order details?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSavingAsDraft: true }));

        let body = {
          assetRequestMovementId: state.assetMovementRequestId,
          fromProjectId: state.fromProjectId,
          fromLocationName: state.fromLocationName,
          toProjectId: state.toProjectId,
          toLocationName: state.toLocationName,
          fromId: state.fromId,
          requestedDate: state.requestedDate,
          note: state.note,
          userId: user?.userId,
          toId: state.userId,
          statusId: AssetSubStatus.MaterialMovementOrderInDraftMode,
          requestNo: state?.materialMovementOrderIndentNo,
          formId: props.featurePermission.featureId,
          applicationId: 3,
          workflowId: state.workflowCategoryId,
          formName: movementOrderfeaturePermission?.featureName,
          departmentId: state.workflowDepartmentId,
          categoryId: state.workflowCategoryId,
          assignedTypeId: state.assignTypeId || 0,
          custodian1DepartmentId: state.custodian1DeptId || 0,
          custodianId1: state.custodianUserId1 || 0,
          custodian2DepartmentId: state.custodian2DeptId || 0,
          custodianId2: state.custodianUserId2 || 0,
          custodian3DepartmentId: state.custodian3DeptId || 0,
          custodianId3: state.custodianUserId3 || 0,
          assignDepartmentId: state.assignDepartmentId || 0,
          assignedId: state.assignedUserId || 0,
          assignedVendorId: state.assignedVendorId || 0,
          assignedVendorName: state.assignedVendorName || "",
          WorkflowCategoryRequest: {},
          movementOrderAttachmentLst:
            movementOrderAttachment.uploadedTemporaryMovementOrderAttachmentLst ??
            [],
          isSaveAsDraft: true,
        };
        const response =
          await assetService.updateMaterialMovementRequestDetails(body);
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        isConfirmed = await showResponseMessage(response);
        if (response?.isSuccess) {
          await getAssetMovementRequest(state.assetMovementRequestId);
          await getAssetMovementRequestSub(state.assetMovementRequestId);
          if (location?.state?.sourceUrl === "MaterialMovementOrder") {
            window.location.href = `/MaterialMovementOrder`;
          } else {
            window.location.href = `/MyTasks`;
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
      console.log(error);
    }
  };

  const handleOnSubmitAssetMovementRequestApprovalDetails = async (e) => {
    e.preventDefault();
    try {
      if (isValidData()) {
        let confirmationQuestion = `Are you sure want To send movement order for approval?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isAssentApprove: true }));
        let updateBody = {
          assetRequestMovementId: state.assetMovementRequestId,
          fromProjectId: state.fromProjectId,
          fromLocationName: state.fromLocationName,
          toProjectId: state.toProjectId,
          toLocationName: state.toLocationName,
          fromId: state.fromId,
          requestedDate: state.requestedDate,
          note: state.note,
          userId: user?.userId,
          toId: state.userId,
          statusId: AssetSubStatus.MaterialMovementOrderSentForApproval,
          requestNo: state?.materialMovementOrderIndentNo,
          formId: props.featurePermission.featureId,
          applicationId: 3,
          workflowId: state.workflowCategoryId,
          formName: movementOrderfeaturePermission?.featureName,
          departmentId: state.workflowDepartmentId,
          categoryId: state.workflowCategoryId,
          assignedTypeId: state.assignTypeId || 0,
          custodian1DepartmentId: state.custodian1DeptId || 0,
          custodianId1: state.custodianUserId1 || 0,
          custodian2DepartmentId: state.custodian2DeptId || 0,
          custodianId2: state.custodianUserId2 || 0,
          custodian3DepartmentId: state.custodian3DeptId || 0,
          custodianId3: state.custodianUserId3 || 0,
          assignDepartmentId: state.assignDepartmentId || 0,
          assignedId: state.assignedUserId || 0,
          assignedVendorId: state.assignedVendorId || 0,
          assignedVendorName: state.assignedVendorName || "",
          WorkflowCategoryRequest: {},
          movementOrderAttachmentLst:
            movementOrderAttachment.uploadedTemporaryMovementOrderAttachmentLst ??
            [],
          isSaveAsDraft: state.isSaveAsDraft,
        };

        await assetService.updateMaterialMovementRequestDetails(updateBody);

        let body = {
          materialMovementRequestId: state.assetMovementRequestId,
          statusId: Number(AssetSubStatus.MaterialMovementOrderSentForApproval),
          Remark: state.remark,
          userId: user?.userId,
          isSentForApproval: true,
        };

        const response = await assetService.updateMaterialMovementRequestStatus(
          body
        );
        setState((prev) => ({ ...prev, isAssentApprove: false }));
        if (!response?.isSuccess) {
          Swal.fire("Error!", `${response?.message}`, "error");
          setState((prev) => ({ ...prev, isAssentApprove: false }));
          return;
        }
        if (location?.state?.sourceUrl === "MaterialMovementOrder") {
          Swal.fire("Success!", `${response?.message}`, "success").then(() => {
            window.location.href = `/MaterialMovementOrder`;
          });
        } else {
          Swal.fire("Success!", `${response?.message}`, "success").then(() => {
            window.location.href = `/MyTasks`;
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isAssentApprove: false }));
    }
    // e.preventDefault();
    // try {
    //   if (!state.isValid) {
    //     let alertMessage = `Please enter material movement details`;
    //     let isConfirmed = await showWarningMessage(alertMessage, "Warning");
    //     return;
    //   }
    //   if (isValidData()) {
    //     let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to update asset movement request details?</span>`;
    //     let isConfirmed = await askConfirmation(
    //       confirmationQuestion,
    //       "Yes",
    //       "No"
    //     );
    //     if (!isConfirmed) return;
    //     setState((prev) => ({ ...prev, isSavingAsDraft: true }));

    //     let workflowCategory = {};
    //     workflowCategory.formId = props.featurePermission.featureId;
    //     workflowCategory.categoryId = state.workflowCategoryId;
    //     workflowCategory.projectId = state.toProjectId;
    //     workflowCategory.departmentId = state.workflowDepartmentId; // user.userDepartmentId;

    //     let body = {
    //       assetRequestMovementId: state.assetMovementRequestId,
    //       fromProjectId: state.fromProjectId,
    //       fromLocationName: state.fromLocationName,
    //       toProjectId: state.toProjectId,
    //       toLocationName: state.toLocationName,
    //       fromId: state.fromId,
    //       requestedDate: state.requestedDate,
    //       note: state.note,
    //       userId: user?.userId,
    //       toId: state.userId,
    //       statusId: AssetSubStatus.MaterialMovementOrderSentForApproval,
    //       requestNo: state?.materialMovementOrderIndentNo,
    //       formId: props.featurePermission.featureId,
    //       applicationId: 3,
    //       workflowId: state.workflowId,
    //       formName: "Material Movement Order",
    //       departmentId: state.workflowDepartmentId,
    //       categoryId: state.workflowCategoryId,
    //       WorkflowCategoryRequest: workflowCategory,
    //       assignedTypeId: state.assignTypeId || 0,
    //       custodian1DepartmentId: state.custodian1DeptId || 0,
    //       custodianId1: state.custodianUserId1 || 0,
    //       custodian2DepartmentId: state.custodian2DeptId || 0,
    //       custodianId2: state.custodianUserId2 || 0,
    //       custodian3DepartmentId: state.custodian3DeptId || 0,
    //       custodianId3: state.custodianUserId3 || 0,
    //       assignDepartmentId: state.assignDepartmentId || 0,
    //       assignedId: state.assignedUserId || 0,
    //       assignedVendorId: state.assignedVendorId || 0,
    //       assignedVendorName: state.assignedVendorName || "",
    //     };

    //     const response =
    //       await assetService.updateMaterialMovementRequestDetails(body);
    //     isConfirmed = await showResponseMessage(response);
    //     setState((prev) => ({ ...prev, isSavingAsDraft: false }));
    //     if (response?.isSuccess) {
    //       await getAssetMovementRequest(state.assetMovementRequestId);
    //       await getAssetMovementRequestSub(state.assetMovementRequestId);
    //       window.location.href = `/MaterialMovementOrder`;
    //     }
    //   }
    // } catch (error) {
    //   setState((prev) => ({ ...prev, isSavingAsDraft: false }));
    //   console.log(error);
    // }
  };

  const isValidAssetMovementRequestSubData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      //err.assetSerialValidation = "";
      err.modesOfTransportationValidation = "";
      err.vehicleNoValidation = "";
      err.vehicleNoTextValidation = "";
      err.vendorNameValidation = "";
      err.transportChargesValidation = "";
      err.remarkValidation = "";
      //   if (state.assetId === 0) {
      //     err.assetSerialValidation = "Please select asset serial number.";
      //     isValid = false;
      //   }
      if (state.modesOfTransportationId === 0) {
        err.modesOfTransportationValidation =
          "Please select modes of transportation.";
        isValid = false;
      }
      if (state.modesOfTransportationId !== 3) {
        if (state.modesOfTransportationId === 1 && !state.vehicleNo) {
          err.vehicleNoValidation = "Please select vehicle no.";
          isValid = false;
        }
        if (state.modesOfTransportationId === 2 && !state.vechicleNoText) {
          err.vehicleNoTextValidation = "Please select vehicle no.";
          isValid = false;
        }
        if (state.modesOfTransportationId === 2 && state.vendorId === 0) {
          err.vendorNameValidation = "Please enter vendor name.";
          isValid = false;
        }
      }

      if (!state.transportCharges || state.transportCharges === 0) {
        err.transportChargesValidation = "Please enter transport charges.";
        isValid = false;
      }
      if (!state.remark) {
        err.remarkValidation = "Please enter remark.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnUpdateAssetMovementRequestSubDetails = async (e) => {
    e.preventDefault();
    try {
      if (isValidAssetMovementRequestSubData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to update movement order sub details?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        let body = {
          assetSerialId: state.assetId,
          assetSerialNumber: state.assetSerialNumber,
          assetName: state.assetName,
          transportationId: state.modesOfTransportationId,
          transportationName: state.modesOfTransportationName,
          vehicleNo:
            state.modesOfTransportationId === 2
              ? state.vechicleNoText
              : state.vehicleNo,
          ewayBillNo: state.ewayBillNo,
          ewayBillExpiryDate: state.ewayBillExpiryDate,
          vendorName: state.vendorName ?? "",
          transportCharges: state.transportCharges,
          remark: state.remark,
          assetMovementRequestSubId: state.rowData?.requestSubId,
          userId: user?.userId,
          custodian1DepartmentId: state.custodian1DeptId || 0,
          custodianId1: state.custodianUserId1 || 0,
          custodian2DepartmentId: state.custodian2DeptId || 0,
          custodianId2: state.custodianUserId2 || 0,
          custodian3DepartmentId: state.custodian3DeptId || 0,
          custodianId3: state.custodianUserId3 || 0,
          assignDepartmentId: state.assignDepartmentId || 0,
          assignedId: state.assignedUserId || 0,
          workOrderId: 0,
          transportVendorId: state.vendorId,
        };
        const response = await assetService.updateMaterialMovementRequestSub(
          body
        );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({
          ...prev,
          isSubmitted: false,
          allocatedAssetId: state.assetId,
        }));
        if (response?.isSuccess) {
          handleOnCloseAssetMovementRequestSubDetailsModal();
          await setAssetDetails(state.assetId);
          await getAssetMovementRequestSub(state.assetMovementRequestId);
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  const handleOnOpenAssetMovementRequestSubDetailsModal = async (e, data) => {
    e.preventDefault();
    try {
      await getTrailerDropdown();
      setState((prev) => ({
        ...prev,
        isUpdateAssetMovementRequestSubDetailsModalOpen: true,
        rowData: data,
        modesOfTransportationId: data?.transportationId ?? 0,
        modesOfTransportationName: data?.transportationName ?? "",
        assetId: data?.allocatedAssetId ?? 0,
        assetSerialNumber: data?.allocatedAssetSerialNo ?? "",
        assetName: data?.allocatedAssetName ?? "",
        vehicleNo: data?.transportVehicle ?? "",
        vechicleNoText: data?.transportVehicle ?? "",
        vendorName: data?.transportVendorName ?? "",
        ewayBillNo: data?.ewayBillNo ?? "",
        ewayBillExpiryDate: data?.ewayBillExpiryDate ?? "",
        transportCharges: data?.transportCharges ?? 0,
        remark: data?.remark ?? "",
        vendorId: data?.vendorId ?? 0,
      }));

      let err = { ...errors };
      //err.assetSerialValidation = "";
      err.modesOfTransportationValidation = "";
      err.vehicleNoValidation = "";
      err.vendorNameValidation = "";
      err.transportChargesValidation = "";
      err.remarkValidation = "";
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseAssetMovementRequestSubDetailsModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isUpdateAssetMovementRequestSubDetailsModalOpen: false,
        rowData: null,
        modesOfTransportationId: 0,
        modesOfTransportationName: "",
        assetId: 0,
        assetSerialNumber: "",
        assetName: "",
        vehicleNo: "",
        vendorName: "",
        vendorId: 0,
        transportCharges: 0,
        //remark: "",
      }));
      setTrailerDropdown([]);
      setAssetSerialDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  const renderGridCurrencyCell = (data) => {
    return (
      <div>
        <i className={CurrencyIcon.ruppesFormat}></i>
        &nbsp;
        {parseFloat(data.value).toFixed(PrecisionFormats[2])}
      </div>
    );
  };

  const setAssetDetails = async (assetId) => {
    try {
      const response = await assetService.getassetList(assetId);
      console.log(response?.data);
      setTimeout(async () => {
        await getCustodian1UserDropdown(
          response?.data[0]?.custodian1DepartmentId
        );
      }, 0);
      setTimeout(async () => {
        await getCustodian2UserDropdown(
          response?.data[0]?.custodian2DepartmentId
        );
      }, 0);
      setTimeout(async () => {
        await getCustodian3UserDropdown(
          response?.data[0]?.custodian3DepartmentId
        );
      }, 0);
      setTimeout(async () => {
        await getAssignedUserDropdown(response?.data[0]?.assignDepartmentId);
      }, 0);

      setState((prev) => ({
        ...prev,
        custodian1DeptId: response?.data[0]?.custodian1DepartmentId ?? 0,
        custodian2DeptId: response?.data[0]?.custodian2DepartmentId ?? 0,
        custodian3DeptId: response?.data[0]?.custodian3DepartmentId ?? 0,

        custodianUserId1: response?.data[0]?.custodianUserId1 ?? 0,
        custodianUserId2: response?.data[0]?.custodianUserId2 ?? 0,
        custodianUserId3: response?.data[0]?.custodianUserId3 ?? 0,

        assignTypeId: response?.data[0]?.assignTypeId ?? 0,
        assignDepartmentId: response?.data[0]?.assignDepartmentId ?? 0,
        assignedUserId: response?.data[0]?.assignUserId ?? 0,
      }));
    } catch (error) {
      console.log("Error getAssetDetails===>", error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div
            className="card-header p-2"
            style={{ backgroundColor: "#e3e7ff" }}
          >
            <div className="float-left">
              <h6 className="mb-0 mt-1">
                Movement Indent Order No&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {state?.materialMovementOrderIndentNo}
                </strong>
                &nbsp;&nbsp; From&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {user?.userDepartmentName}
                </strong>
                &nbsp;&nbsp;&nbsp;Date&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {moment(new Date()).format(
                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                  )}
                </strong>
              </h6>
            </div>
            <div className="float-right">
              {/* <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  //await handleOnUpdateAssetRequest(e);
                }}
              >
               <span title="Approve">
                  <i
                    className={`fas fa-${
                      state.isApproving
                        ? "spinner fa-spin"
                        : "file-signature"
                    }`}
                  />
                  &nbsp;&nbsp;Approve
                </span>
              </button>
              &nbsp;&nbsp; */}
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  // window.location.href = "/AssetMovement";

                  if (location?.state?.sourceUrl === "MaterialMovementOrder") {
                    navigate("/MaterialMovementOrder");
                  } else {
                    navigate("/MyTasks");
                  }
                }}
              >
                <span title="Cancel ">
                  <i className="fas fa-times" />
                  &nbsp;&nbsp;Cancel
                </span>
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  await handleOnSubmitAssetMovementRequestDetails(e);
                }}
                disabled={state.isAssentApprove}
                //hidden={state.isAssentApprove}
              >
                <span title="Save As Draft">
                  <i
                    className={`fas fa-${
                      state.isSavingAsDraft
                        ? "spinner fa-spin"
                        : "file-signature"
                    }`}
                  />
                  &nbsp;&nbsp;Save As Draft
                </span>
              </button>
              {state.isSaveAsDraft && (
                <>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={async (e) => {
                      await handleOnSubmitAssetMovementRequestApprovalDetails(
                        e
                      );
                    }}
                    disabled={state.isSavingAsDraft}
                    //hidden={state.isSavingAsDraft}
                  >
                    <span title="Send">
                      <i
                        className={`fas fa-${
                          state.isAssentApprove ? "spinner fa-spin" : "check"
                        }`}
                      />
                      &nbsp;&nbsp;Send for Approval
                    </span>
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-4" style={{ display: "none" }}>
                <div className="form-group mb-2">
                  <label>
                    To &nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={userDropdown}
                    className={`form-control ${
                      errors.userValidation ? "is-invalid" : ""
                    }`}
                    classNamePrefix="select"
                    placeholder="Select user"
                    name="userDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.userId}
                    defaultValue={state.userId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.userValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        userId: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.userValidation && (
                    <div className="text-danger">{errors.userValidation}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-4" style={{ display: "none" }}>
                <div className="form-group mb-2">
                  <label>
                    From Project&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={fromProjectDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select from project"
                    name="fromProjectDropdown"
                    displayExpr="projectName"
                    valueExpr="id"
                    value={state.fromProjectId}
                    defaultValue={state.fromProjectId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.fromProjectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        fromProjectId: e?.selectedItem?.id ?? 0,
                        fromProjectName: e?.selectedItem?.projectName ?? "",
                        fromLocationName: e?.selectedItem?.location ?? "",
                        // toProjectId: 0,
                        // toProjectName: "",
                        // toLocationName: "",
                      }));
                      //await getWorkflowCategory(e?.selectedItem?.id ?? 0);
                      // setToProjectDropdown([]);
                      // if (e?.selectedItem?.id > 0) {
                      //   await getToProjectDropdown(e?.selectedItem?.id);
                      // }
                    }}
                  />
                  {errors.fromProjectValidation && (
                    <div className="text-danger">
                      {errors.fromProjectValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    To Project&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={toProjectDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select to project"
                    height={38}
                    name="toProjectDropdown"
                    displayExpr="projectName"
                    valueExpr="id"
                    value={state.toProjectId}
                    defaultValue={state.toProjectId}
                    disabled={true}
                    showClearButton={true}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.toProjectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        toProjectId: e?.selectedItem?.id ?? 0,
                        toProjectName: e?.selectedItem?.projectName ?? "",
                        toLocationName: e?.selectedItem?.location ?? "",
                      }));
                      //await getWorkflowCategory(e?.selectedItem?.id ?? 0);
                    }}
                  />
                  {errors.toProjectValidation && (
                    <div className="text-danger">
                      {errors.toProjectValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Category<span className="text-danger">*</span>
                  </label>
                  <div className="d-flex">
                    <SelectBox
                      dataSource={workflowCategoryDropdown}
                      className={`form-control ${errors.workflowCategoryValidation ? "is-invalid" : ""
                        }`}
                      classNamePrefix="select"
                      placeholder="Select category"
                      name="workflowCategoryDropdown"
                      displayExpr="name"
                      valueExpr="id"
                      value={state.workflowCategoryId}
                      defaultValue={state.workflowCategoryId}
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      onSelectionChanged={async (e) => {
                        let err = { ...errors };
                        err.workflowCategoryValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          workflowCategoryId: e?.selectedItem?.id ?? 0,
                        }));
                      }}
                    />
                  </div>
                  {errors.workflowCategoryValidation && (
                    <div className="text-danger">{errors.workflowCategoryValidation}</div>
                  )}
                </div>
              </div> */}
              {/* <div className="col-12 col-lg-4">
                <div className="form-gorup mb-2">
                  <TextBox
                    className="form-control"
                    disabled={true}
                    value={state.fromLocationName}
                    height={36}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="form-gorup mb-2">
                  <TextBox
                    className="form-control"
                    disabled={true}
                    value={state.toLocationName}
                    height={36}
                  />
                </div>
              </div> */}
            </div>
            <br />
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <DataGrid
                    ref={refDataGrid}
                    keyExpr="requestSubId"
                    dataSource={assetMovementRequestSubDataSourceLst}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={true}
                    height={300}
                    onToolbarPreparing={(e) => {
                      e.toolbarOptions.items.unshift({
                        location: "before",
                        template: "toolbarTitleTemplate",
                      });
                    }}
                  >
                    <Column
                      dataField="requestSubId"
                      caption=""
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      width={80}
                      cellRender={(data) => {
                        return (
                          // <Icon
                          //   className="iconify-size mr-1"
                          //   title="Edit"
                          //   tooltip="Edit"
                          //   icon="solar:pen-line-duotone"
                          //   style={{ cursor: "pointer" }}
                          //   onClick={(e) => {
                          //     handleOnOpenAssetMovementRequestSubDetailsModal(
                          //       e,
                          //       data?.data
                          //     );
                          //   }}
                          // />

                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Assign"
                            className="btn btn-primary btn-sm-1"
                            onClick={async (e) => {
                              // if (state.fromProjectId === 0) {
                              //   let alertMessage = `Please select from project`;
                              //   let isConfirmed = await showWarningMessage(
                              //     alertMessage,
                              //     "Warning"
                              //   );
                              //   return;
                              // }
                              await handleOnOpenAssetMovementRequestSubDetailsModal(
                                e,
                                data?.data
                              );
                            }}
                          >
                            {/* <FontAwesomeIcon icon={faArrowCircleRight} /> */}
                            <Icon
                              icon="material-symbols-light:assignment-add-outline-sharp"
                              width="14"
                              height="14"
                            />
                            &nbsp;&nbsp;Assign
                          </button>
                        );
                      }}
                    />
                    <Column
                      dataField="workOrderNo"
                      caption="Purchase/Work Order No"
                      allowSearch={true}
                    />
                    <Column
                      dataField="materialDesc"
                      caption="Description"
                      allowSearch={true}
                    />
                    <Column
                      dataField=""
                      caption="Transport"
                      allowSearch={true}
                      alignment={"center"}
                      cellRender={(data) => {
                        //if (data?.data?.transportVehicle) {
                        if (data?.data?.transportationId == 1) {
                          return (
                            <>
                              <div>{data?.data?.transportationName ?? ""}</div>
                              <small style={{ fontSize: "12px" }}>
                                {data?.data?.transportVehicle ?? ""}
                                &nbsp;&nbsp;[
                                {data?.data?.transportationName ?? ""}]
                              </small>
                            </>
                          );
                        } else if (data?.data?.transportationId == 2) {
                          return (
                            <>
                              <div>{data?.data?.transportVendorName ?? ""}</div>
                              <small style={{ fontSize: "12px" }}>
                                {data?.data?.transportVehicle ?? ""}
                                &nbsp;&nbsp;[
                                {data?.data?.transportationName ?? ""}]
                              </small>
                            </>
                          );
                        } else {
                          return <></>;
                        }
                      }}
                    />
                    <Column
                      dataField="transportCharges"
                      caption="Transport Charges"
                      allowSearch={true}
                    />
                    <Column
                      dataField="fromProjectName"
                      caption="From Location"
                      allowSearch={true}
                    />
                    <Column
                      dataField="remark"
                      caption="Remark"
                      allowSearch={true}
                    />
                    <Template
                      name="toolbarTitleTemplate"
                      render={() => {
                        return (
                          <>
                            <h3 className="mainheading mb-0">
                              Asset Request Details
                            </h3>
                          </>
                        );
                      }}
                    />
                    <HeaderFilter visible={false} />
                    <Scrolling mode="Asset Movement Request" />
                    <SearchPanel
                      visible={true}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                  </DataGrid>
                </div>
              </div>
            </div>
            {state.allocatedAssetId > 0 && (
              <>
                <br />
                <div className="card">
                  <div className="card-header p-2">
                    <h3 className="mainheading mb-0">Custodian Information</h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>Department (Custodian 1)</label>
                          <SelectBox
                            dataSource={custodian1DepartmentDropdown?.filter(
                              (f) =>
                                f.id !== state.custodian2DeptId &&
                                f.id !== state.custodian3DeptId
                            )}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select department"
                            name="custodian1DepartmentDropdown"
                            displayExpr="departmentName"
                            valueExpr="id"
                            value={state.custodian1DeptId}
                            defaultValue={state.custodian1DeptId}
                            showClearButton={true}
                            disabled={true}
                            searchEnabled={true}
                            onSelectionChanged={async (e) => {
                              let err = { ...errors };
                              err.custodian1DepartmentValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                custodian1DeptId: e?.selectedItem?.id ?? 0,
                                custodianUserId1: 0,
                              }));
                              setCustodian1UserDropdown([]);
                              if (e?.selectedItem?.id > 0) {
                                await getCustodian1UserDropdown(
                                  e?.selectedItem?.id
                                );
                              }
                            }}
                          />
                          {errors.custodian1DepartmentValidation && (
                            <div className="text-danger">
                              {errors.custodian1DepartmentValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>Custodian 1</label>
                          <SelectBox
                            dataSource={custodian1UserDropdown?.filter(
                              (f) =>
                                f.id !== state.custodianUserId2 &&
                                f.id !== state.custodianUserId3
                            )}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select custodian 1"
                            name="custodian1UserDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.custodianUserId1}
                            defaultValue={state.custodianUserId1}
                            showClearButton={true}
                            disabled={true}
                            searchEnabled={true}
                            onSelectionChanged={async (e) => {
                              let err = { ...errors };
                              err.custodian1UserValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                custodianUserId1: e?.selectedItem?.id ?? 0,
                              }));
                            }}
                          />
                          {errors.custodian1UserValidation && (
                            <div className="text-danger">
                              {errors.custodian1UserValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>Department (Custodian 2)</label>
                          <SelectBox
                            dataSource={custodian2DepartmentDropdown?.filter(
                              (f) =>
                                f.id !== state.custodian1DeptId &&
                                f.id !== state.custodian3DeptId
                            )}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select department"
                            name="custodian2DepartmentDropdown"
                            displayExpr="departmentName"
                            valueExpr="id"
                            value={state.custodian2DeptId}
                            defaultValue={state.custodian2DeptId}
                            showClearButton={true}
                            disabled={true}
                            searchEnabled={true}
                            onSelectionChanged={async (e) => {
                              let err = { ...errors };
                              err.custodian2DepartmentValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                custodian2DeptId: e?.selectedItem?.id ?? 0,
                                custodianUserId2: 0,
                              }));
                              setCustodian2UserDropdown([]);
                              if (e?.selectedItem?.id > 0) {
                                await getCustodian2UserDropdown(
                                  e?.selectedItem?.id
                                );
                              }
                            }}
                          />
                          {errors.custodian2DepartmentValidation && (
                            <div className="text-danger">
                              {errors.custodian2DepartmentValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>Custodian 2</label>
                          <SelectBox
                            dataSource={custodian2UserDropdown?.filter(
                              (f) =>
                                f.id !== state.custodianUserId1 &&
                                f.id !== state.custodianUserId3
                            )}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select custodian 2"
                            name="custodian2UserDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.custodianUserId2}
                            defaultValue={state.custodianUserId2}
                            showClearButton={true}
                            disabled={true}
                            searchEnabled={true}
                            onSelectionChanged={async (e) => {
                              let err = { ...errors };
                              err.custodian2UserValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                custodianUserId2: e?.selectedItem?.id ?? 0,
                              }));
                            }}
                          />
                          {errors.custodian2UserValidation && (
                            <div className="text-danger">
                              {errors.custodian2UserValidation}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>Department (Custodian 3)</label>
                          <SelectBox
                            dataSource={custodian3DepartmentDropdown?.filter(
                              (f) =>
                                f.id !== state.custodian1DeptId &&
                                f.id !== state.custodian2DeptId
                            )}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select department"
                            name="custodian3DepartmentDropdown"
                            displayExpr="departmentName"
                            valueExpr="id"
                            value={state.custodian3DeptId}
                            defaultValue={state.custodian3DeptId}
                            showClearButton={true}
                            disabled={false}
                            searchEnabled={true}
                            onSelectionChanged={async (e) => {
                              let err = { ...errors };
                              err.custodian3DepartmentValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                custodian3DeptId: e?.selectedItem?.id ?? 0,
                                custodianUserId3: 0,
                              }));
                              setCustodian3UserDropdown([]);
                              if (e?.selectedItem?.id > 0) {
                                await getCustodian3UserDropdown(
                                  e?.selectedItem?.id
                                );
                              }
                            }}
                          />
                          {errors.custodian3DepartmentValidation && (
                            <div className="text-danger">
                              {errors.custodian3DepartmentValidation}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>Custodian 3</label>
                          <SelectBox
                            dataSource={custodian3UserDropdown?.filter(
                              (f) =>
                                f.id !== state.custodianUserId1 &&
                                f.id !== state.custodianUserId2
                            )}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select custodian 3"
                            name="custodian3UserDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.custodianUserId3}
                            defaultValue={state.custodianUserId3}
                            showClearButton={true}
                            disabled={false}
                            searchEnabled={true}
                            onSelectionChanged={async (e) => {
                              let err = { ...errors };
                              err.custodian3UserValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                custodianUserId3: e?.selectedItem?.id ?? 0,
                              }));
                            }}
                          />
                          {errors.custodian3UserValidation && (
                            <div className="text-danger">
                              {errors.custodian3UserValidation}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>Assign To</label>
                          <SelectBox
                            dataSource={assignTypeDropdown}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="Select assign type"
                            name="assignTypeDropdown"
                            displayExpr="name"
                            valueExpr="id"
                            value={state.assignTypeId}
                            defaultValue={state.assignTypeId}
                            showClearButton={true}
                            disabled={false}
                            readOnly={
                              state.rowData?.assignDepartmentId > 0 ||
                              state.rowData?.assignedUserId > 0
                                ? true
                                : false
                            }
                            searchEnabled={true}
                            onSelectionChanged={(e) => {
                              let err = { ...errors };
                              err.assignTypeValidation = "";
                              setErrors(err);
                              setState((prev) => ({
                                ...prev,
                                assignTypeId: e?.selectedItem?.id ?? 0,
                                assignTypeName: e?.selectedItem?.name ?? "",
                                assignDepartmentId: 0,
                                assignDepartmentName: "",
                                //assignedUserId: 0,
                                assignUserName: "",
                              }));
                            }}
                          />
                          {errors.assignTypeValidation && (
                            <div className="text-danger">
                              {errors.assignTypeValidation}
                            </div>
                          )}
                        </div>
                      </div>

                      {(state.assignTypeId === 1 ||
                        state.assignTypeId === 2) && (
                        <>
                          <div
                            className={`col-12 col-lg-${
                              state.assignTypeId === 1 ? "3" : "3"
                            }`}
                          >
                            <div className="form-group mb-2">
                              <label>
                                Department
                                {state.assignDepartmentId === 0 && (
                                  <>
                                    &nbsp;<span className="text-danger">*</span>
                                  </>
                                )}
                              </label>
                              <SelectBox
                                dataSource={assignDepartmentDropdown}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select department"
                                name="assignDepartmentDropdown"
                                displayExpr="departmentName"
                                valueExpr="id"
                                value={state.assignDepartmentId}
                                defaultValue={state.assignDepartmentId}
                                showClearButton={true}
                                readOnly={
                                  state.rowData?.assignDepartmentId > 0
                                    ? true
                                    : false
                                }
                                searchEnabled={true}
                                onSelectionChanged={async (e) => {
                                  let err = { ...errors };
                                  err.assignDepartmentValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    assignDepartmentId:
                                      e?.selectedItem?.id ?? 0,
                                    assignDepartmentName:
                                      e?.selectedItem?.departmentName ?? "",
                                    //assignedUserId: 0,
                                    assignUserName: "",
                                  }));
                                  setAssignUserDropdown([]);
                                  if (e?.selectedItem?.id > 0) {
                                    await getAssignedUserDropdown(
                                      e?.selectedItem?.id
                                    );
                                  }
                                }}
                              />
                              {errors.assignDepartmentValidation && (
                                <div className="text-danger">
                                  {errors.assignDepartmentValidation}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}

                      {(state.assignTypeId === 3) > 0 && (
                        <>
                          <div className="col-12 col-lg-3">
                            <div className="form-group mb-2">
                              <label>Vendor</label>
                              <SelectBox
                                dataSource={assignedVendorDropdown}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select vendor"
                                name="assignedVendorDropdown"
                                displayExpr="name"
                                valueExpr="id"
                                value={state.assignedVendorId}
                                defaultValue={state.assignedVendorId}
                                showClearButton={true}
                                disabled={false}
                                searchEnabled={true}
                                onInput={(e) => {
                                  const searchText =
                                    e?.event?.target?.value || "";
                                  debouncedAssignedVendorSearch(searchText);
                                }}
                                onSelectionChanged={async (e) => {
                                  let err = { ...errors };
                                  err.assignedVendorValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    assignedVendorId: e?.selectedItem?.id ?? 0,
                                  }));
                                }}
                              />
                              {errors.assignedVendorValidation && (
                                <div className="text-danger">
                                  {errors.assignedVendorValidation}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-lg-3">
                            <div className="form-group mb-2">
                              <label>Vendor Name&nbsp;</label>
                              <TextBox
                                name="assignedVendorName"
                                className="form-control form-control-sm"
                                height={37}
                                placeholder="Enter vendor name"
                                showClearButton={true}
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                  let err = { ...errors };
                                  err.assignedVendorNameValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    assignedVendorName: e.value ?? "",
                                  }));
                                }}
                                value={state.assignedVendorName}
                              />
                              {errors.assignedVendorNameValidation && (
                                <div className="text-danger">
                                  {errors.assignedVendorNameValidation}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}

                      {(state.assignTypeId === 1 ||
                        state.assignTypeId === 2) && (
                        <>
                          <div className="col-12 col-lg-3">
                            <div className="form-group mb-2">
                              <label>
                                User
                                {state.assignedUserId === 0 && (
                                  <>
                                    &nbsp;<span className="text-danger">*</span>
                                  </>
                                )}
                              </label>
                              <SelectBox
                                dataSource={assignUserDropdown}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select user"
                                name="assignUserDropdown"
                                displayExpr="name"
                                valueExpr="id"
                                value={state.assignedUserId}
                                defaultValue={state.assignedUserId}
                                showClearButton={true}
                                readOnly={
                                  state.rowData?.assignedUserId > 0
                                    ? true
                                    : false
                                }
                                searchEnabled={true}
                                onSelectionChanged={async (e) => {
                                  let err = { ...errors };
                                  err.assignUserValidation = "";
                                  setErrors(err);
                                  setState((prev) => ({
                                    ...prev,
                                    assignedUserId: e?.selectedItem?.id ?? 0,
                                    assignUserName: e?.selectedItem?.name ?? "",
                                  }));
                                }}
                              />
                              {errors.assignUserValidation && (
                                <div className="text-danger">
                                  {errors.assignUserValidation}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            <br />
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label
                    htmlFor="fileUpload"
                    className="btn btn-outline-primary mb-1"
                    style={{ cursor: "pointer" }}
                    title="Attachment"
                  >
                    <i className="fas fa-plus"></i>&nbsp;Attachment
                  </label>
                  <input
                    id="fileUpload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={async (e) => {
                      await handlemovementOrderFileChange(e);
                    }}
                  />
                </div>
                <div className="attachment-container">
                  {movementOrderAttachment?.uploadedTemporaryMovementOrderAttachmentLst?.map(
                    (file, idx) => (
                      <div key={idx} className="attachment-item">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          <div
                            className="attachment-name"
                            onClick={() => {
                              if (file?.filePath) {
                                window.open(file?.fileUrl, "_blank");
                              }
                            }}
                          >
                            {file?.fileName}
                          </div>
                          {file?.id === 0 && (
                            <button
                              className="btn pt-0 pb-0 pr-0"
                              onClick={() => {
                                setMovementOrderAttachment((prev) => ({
                                  ...prev,
                                  uploadedTemporaryMovementOrderAttachmentLst:
                                    movementOrderAttachment.uploadedTemporaryMovementOrderAttachmentLst?.filter(
                                      (_, i) => i !== idx
                                    ),
                                }));
                              }}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          )}
                        </div>
                        <div className="small">
                          {(file?.fileSize / 1024).toFixed(0)} kb
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label>
                    Note&nbsp;<span className="text-danger">*</span>
                  </label>
                  <TextArea
                    className="form-control"
                    placeholder="Enter note"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={state.note}
                    onValueChanged={(e) => {
                      let err = { ...errors };
                      err.noteValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        note: e.value,
                      }));
                    }}
                  />
                  {errors.noteValidation && (
                    <div className="text-danger">{errors.noteValidation}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {assetRequestApprovers?.[0]?.actionTypeId === 8 ? (
                ""
              ) : (
                <>
                  <div className="col-lg-4 col-md-12 col-sm-4">
                    <div className="form-group">
                      {assetRequestApprovers?.[0]?.actionTypeId === 8 ? (
                        ""
                      ) : (
                        <label>Prepared By</label>
                      )}
                      {assetRequestApprovers?.id ? (
                        <TextBox
                          className="form-control"
                          placeholder="Enter name"
                          showClearButton={false}
                          value={
                            assetRequestApprovers?.fromUser +
                            " (" +
                            assetRequestApprovers?.fromUserDesignation +
                            ")"
                          }
                          readOnly={true}
                        />
                      ) : assetRequestApprovers?.[0]?.actionTypeId === 8 ? (
                        ""
                      ) : (
                        <TextBox
                          className="form-control"
                          placeholder="Enter name"
                          showClearButton={false}
                          value={
                            user?.firstName +
                            " " +
                            user?.lastName +
                            " (" +
                            user?.userDesignationName +
                            ")"
                          }
                          readOnly={true}
                        />
                      )}
                    </div>
                  </div>
                </>
              )}

              {assetRequestApproversByWorkflow?.map((stage, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start"
                >
                  <div className="w-100">
                    <label className="form-label">
                      {stage?.actionTypeName}
                    </label>
                    {stage?.approvers?.map((approver, i) => (
                      <input
                        key={i}
                        type="text"
                        className="form-control"
                        value={`${approver?.userName} (${approver?.designationName})`}
                        readOnly
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
            {/* <div className="row">
              <div className="col-lg-4 col-md-12 col-sm-4">
                <div className='form-group'>
                  <label>Prepared By</label>
                  <TextBox
                    className="form-control"
                    placeholder="Enter name"
                    showClearButton={false}
                    value={user?.firstName + " " + user?.lastName + " (" + user?.userDesignationName + ")"}
                    readOnly={true}
                  />
                </div>
              </div>

              {assetRequestApproversByWorkflow?.map((stage, index) => (
                <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                  <div className="w-100">
                    <label className="form-label">{stage?.actionTypeName}</label>
                    {stage?.approvers?.map((approver, i) => (
                      <input
                        key={i}
                        type="text"
                        className="form-control"
                        value={`${approver?.userName} (${approver?.designationName})`}
                        readOnly
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={state.isUpdateAssetMovementRequestSubDetailsModalOpen}
        onAfterOpen={async () => {
          await getAssetSerialDropdown();
          await getVendorDropdown("", state.vendorId);
          //await getTrailerDropdown();
          let err = { ...errors };
          //err.assetSerialValidation = "";
          err.modesOfTransportationValidation = "";
          err.vehicleNoValidation = "";
          err.vendorNameValidation = "";
          err.transportChargesValidation = "";
          err.remarkValidation = "";
        }}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add Asset Attachment"
      >
        <div className="modal-header">
          <h6 className="modal-title">{`Material Allocation`}</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAssetMovementRequestSubDetailsModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Material Description</label>
                <p className="mb-0 textinfo">
                  {state.rowData?.materialDesc ?? ""}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Movement Qty</label>
                <p className="mb-0 textinfo">
                  {state.rowData?.movementQuantity ?? 0}
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Purchase/Work Order No</label>
                <p className="mb-0 textinfo">{state.rowData?.workOrderNo}</p>
              </div>
            </div>
          </div>
          <div className="row">
            {/* <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Date Of Requirement</label>
                <p className="mb-0 textinfo">
                  {state.rowData?.requirementDate
                    ? moment(state.rowData?.requirementDate)
                        .format(DefaultDateFormat.MomentDisplayDateFormat)
                        .toString()
                    : ""}
                </p>
              </div>
            </div> */}
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>UOM</label>
                <p className="mb-0 textinfo">{state.rowData?.uomName ?? ""}</p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>From Location</label>
                <p className="mb-0 textinfo">
                  {state.rowData?.fromProjectName ?? ""}
                </p>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>Purpose</label>
                <p className="mb-0 textinfo">{state.rowData?.purpose ?? ""}</p>
              </div>
            </div>
          </div> */}
          <hr></hr>
          <div className="row">
            {/* <div className="col-12 col-lg-4">
              <div className="form-group">
                <label>
                  Asset Id #&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={assetSerialDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select asset id #"
                  name="assetSerialDropdown"
                  displayExpr="assetSerial"
                  valueExpr="assetId"
                  value={state.assetId}
                  defaultValue={state.assetId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.assetSerialValidation = "";
                    setErrors(err);
                    setAssetDetails(e);
                    setState((prev) => ({
                      ...prev,
                      assetId: e?.selectedItem?.assetId ?? 0,
                      assetSerialNumber: e?.selectedItem?.assetSerial ?? "",
                      assetName: e?.selectedItem?.name ?? "",
                    }));
                  }}
                />
                {errors.assetSerialValidation && (
                  <div className="text-danger">
                    {errors.assetSerialValidation}
                  </div>
                )}
                {state.assetId > 0 && (
                  <div style={{ color: "#414040ff", fontSize: "11px" }}>
                    <b>{state.assetName}</b>
                  </div>
                )}
              </div>
            </div> */}
            <div className="col-12 col-lg-4">
              <div className="form-group">
                <label>
                  Movement Type&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={modesOfTransportationLst}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select movement type"
                  name="modesOfTransportationLst"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.modesOfTransportationId}
                  defaultValue={state.modesOfTransportationId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.modesOfTransportationValidation = "";
                    err.vehicleNoValidation = "";
                    err.vendorNameValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      modesOfTransportationId: e?.selectedItem?.id ?? 0,
                      modesOfTransportationName: e?.selectedItem?.name ?? "",
                      // vendorName: "",
                      // vehicleNo: "",
                    }));
                  }}
                />
                {errors.modesOfTransportationValidation && (
                  <div className="text-danger">
                    {errors.modesOfTransportationValidation}
                  </div>
                )}
              </div>
            </div>
            {state.modesOfTransportationId === 1 && (
              <>
                <div className="col-12 col-lg-4">
                  <div className="form-group">
                    <label>
                      Vehicle No.&nbsp;<span className="text-danger">*</span>
                    </label>
                    <SelectBox
                      dataSource={trailerDropdown}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select vehicle"
                      name="trailerDropdown"
                      displayExpr="assetSerial"
                      valueExpr="assetSerial"
                      value={state.vehicleNo}
                      defaultValue={state.vehicleNo}
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      onSelectionChanged={async (e) => {
                        let err = { ...errors };
                        err.vehicleNoValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          vehicleNo: e?.selectedItem?.assetSerial ?? "",
                        }));
                      }}
                    />
                    {errors.vehicleNoValidation && (
                      <div className="text-danger">
                        {errors.vehicleNoValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {state.modesOfTransportationId === 2 && (
              <>
                <div className="col-12 col-lg-4">
                  <div className="form-group">
                    <label>
                      Vendor&nbsp;<span className="text-danger">*</span>
                    </label>
                    <SelectBox
                      dataSource={vendorDropdown}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select vendor"
                      name="vendorDropdown"
                      displayExpr="name"
                      valueExpr="id"
                      value={state.vendorId}
                      defaultValue={state.vendorId}
                      showClearButton={true}
                      searchEnabled={true}
                      readOnly={false}
                      disabled={false}
                      onInput={(e) => {
                        const searchText = e?.event?.target?.value || "";
                        debouncedVendorSearch(searchText);
                      }}
                      onSelectionChanged={(e) => {
                        let err = { ...errors };
                        err.vendorNameValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          vendorId: e?.selectedItem?.id ?? 0,
                          vendorName: e?.selectedItem?.vendorName ?? "",
                        }));
                      }}
                    />
                    {errors.vendorNameValidation && (
                      <div className="text-danger">
                        {errors.vendorNameValidation}
                      </div>
                    )}
                    {/* <TextBox
                      className="form-control"
                      placeholder="Enter vendor name"
                      showClearButton={true}
                      valueChangeEvent="keyup"
                      value={state.vendorName}
                      onValueChanged={(e) => {
                        let err = { ...errors };
                        err.vendorNameValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          vendorName: e?.value,
                        }));
                      }}
                    />
                    {errors.vendorNameValidation && (
                      <div className="text-danger">
                        {errors.vendorNameValidation}
                      </div>
                    )} */}
                  </div>
                </div>
                <div className="col-12 col-lg-4">
                  <div className="form-group mb-2">
                    <label>
                      Vehicle No&nbsp;<span className="text-danger">*</span>
                    </label>
                    <TextBox
                      className="form-control"
                      placeholder="Enter vehicle no."
                      showClearButton={true}
                      valueChangeEvent="keyup"
                      value={state.vechicleNoText}
                      onValueChanged={(e) => {
                        let err = { ...errors };
                        err.vehicleNoTextValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          vechicleNoText: e?.value,
                        }));
                      }}
                    ></TextBox>
                    {errors.vehicleNoTextValidation && (
                      <div className="text-danger">
                        {errors.vehicleNoTextValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {state.modesOfTransportationId !== 3 && (
              <>
                <div className="col-12 col-lg-4">
                  <div className="form-group">
                    <label>
                      Transport Charges&nbsp;
                      <span className="text-danger">*</span>
                    </label>
                    <NumberBox
                      className="form-control"
                      placeholder="Enter Transport Charges"
                      showClearButton={true}
                      valueChangeEvent="keyup"
                      value={Number(state.transportCharges ?? 0) || ""}
                      onValueChanged={(e) => {
                        let err = { ...errors };
                        err.transportChargesValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          transportCharges: e?.value,
                        }));
                      }}
                    />
                    {errors.transportChargesValidation && (
                      <div className="text-danger">
                        {errors.transportChargesValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            {state.modesOfTransportationId === 1 && (
              <div className="col-12 col-lg-4"></div>
            )}
            {/* {state.modesOfTransportationId !== 3 && (
              <>
                <div className="col-12 col-lg-4">
                  <div className="form-group">
                    <label>
                      E-Way Bill No.&nbsp;<span className="text-danger"></span>
                    </label>
                    <TextBox
                      className="form-control"
                      placeholder="Enter e-way bill no."
                      showClearButton={true}
                      valueChangeEvent="keyup"
                      value={state.ewayBillNo}
                      onValueChanged={(e) => {
                        let err = { ...errors };
                        err.ewayBillNoValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          ewayBillNo: e?.value,
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-4">
                  <div className="form-group">
                    <label>E-Way Expiry Date</label>
                    <DateBox
                      type="date"
                      className="form-control"
                      name="ewayDate"
                      placeholder="Enter e-way expiry date"
                      displayFormat={DefaultDateFormat.GridDateFormat}
                      showAnalogClock={false}
                      useMaskBehavior={false}
                      defaultValue={state?.ewayBillExpiryDate}
                      value={state?.ewayBillExpiryDate}
                      min={moment(new Date(), "MM/DD/YYYY").add(0, "day")}
                      disabled={false}
                      acceptCustomValue={true}
                      onValueChanged={(date) => {
                        setState((prev) => ({
                          ...prev,
                          ewayBillExpiryDate: date.value,
                        }));
                      }}
                    />
                  </div>
                </div>
              </>
            )} */}
          </div>
          <div className="row">
            {" "}
            <div
              className={`col-12 col-lg-${
                state.modesOfTransportationId > 0 ? 12 : 12
              }`}
            >
              <div className="form-group mb-2">
                <label>
                  Remark&nbsp;<span className="text-danger">*</span>
                </label>
                <TextBox
                  className="form-control"
                  placeholder="Enter remark"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  value={state.remark}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.remarkValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      remark: e?.value,
                    }));
                  }}
                />
                {errors.remarkValidation && (
                  <div className="text-danger">{errors.remarkValidation}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnUpdateAssetMovementRequestSubDetails(e);
            }}
            disabled={state.isSubmitted}
          >
            <span title="Submit">
              <i
                className={`fas fa-${
                  state.isSubmitted ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAssetMovementRequestSubDetailsModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
